/**
 * The WhatsApp number screen's small rules (2026-09-11) — import-free, so the node-tests execute this
 * exact file (cypress/node-tests/whatsapp-number-choice.test.js).
 *
 * The screen shows the numbers `my-number-options` returns: a RECOMMENDED list (chosen server-side
 * from where the practice is — conversations-service lib/waOnboarding/numberOptions.js) and the
 * practice's own area-code search. The server says HOW it chose (`basis`); the words for it live
 * here, next to the other copy rules, so no sentence depends on the server's phrasing.
 */

/**
 * One line saying why the top number was suggested, or '' when there is nothing honest to say.
 * @param {{ basis?: string, areaCode?: ?string, region?: ?string }} result  a my-number-options body
 * @returns {string}
 */
export function recommendationReason(result) {
  if (!result || typeof result !== 'object') return '';
  switch (result.basis) {
    case 'office_area_code':
      return result.areaCode ? `In your office's area code, ${result.areaCode}.` : "In your office's area code.";
    case 'near_office':
      return 'Near your office.';
    case 'near_practice':
      return "Near your practice's address.";
    case 'state':
      return result.region ? `In your state, ${result.region}.` : 'In your state.';
    case 'florida':
      return 'A Florida number, from the closest US state to your practice.';
    default:
      return '';
  }
}

/**
 * Is this number one the screen is actually showing? Only an offered number may be bought — a number
 * from an earlier list, or one the page never showed, must not reach the purchase.
 * @param {string} phoneNumber
 * @param {...?{numbers?: Array}} results
 * @returns {boolean}
 */
export function isOffered(phoneNumber, ...results) {
  if (typeof phoneNumber !== 'string' || phoneNumber === '') return false;
  return results.some((r) => r && Array.isArray(r.numbers)
    && r.numbers.some((n) => n && n.phoneNumber === phoneNumber));
}

/** Said when an area-code search comes back empty. */
export function searchEmptyMessage(areaCode) {
  return areaCode
    ? `No numbers are available in ${areaCode} right now. Try a nearby area code.`
    : 'No numbers are available for that search right now. Try a nearby area code.';
}
